import React from 'react';
import { Button } from 'semantic-ui-react';

export const DashboardButton = ({ item, onClick, testId }) => {
  return (
    <Button
      as="button"
      color={item?.color}
      content={item.text}
      data-testid={`${testId}-${item.text}-button`}
      disabled={item.hasOwnProperty('qty') && Number(item.qty) === 0}
      icon={item.iconClass}
      key={item.text}
      label={
        item.hasOwnProperty('qty')
          ? {
              as: 'button',
              basic: true,
              color: item.color,
              style: {
                width: '90px',
                display: 'flex',
                justifyContent: 'center',
                fontSize: '.8em',
                zIndex: 0,
              },
              pointing: 'left',
              content: item.qty,
            }
          : null
      }
      onClick={() => onClick(item)}
      size="mini"
    />
  );
};
